import { Rem } from './fontSizeProps';

export const BASE_FONT_SIZE = 16;

export function remToPx(rem: number, base?: number) {
  const fontSize = base || BASE_FONT_SIZE;

  return fontSize * rem;
}

export function pxToRem(px: number, base?: number): Rem {
  const baseFontSize = base || BASE_FONT_SIZE;

  // Convert the pixel value to rems
  const rem = px / baseFontSize;

  // Return the rem value
  return `${rem}rem`;
}

export function convertValueToPx(value: number | Rem, base?: number) {
  if (typeof value === 'number') {
    return value;
  }

  // get the number from the rem string
  const number = parseFloat(value.split('r')[0]);
  // check if number is valid
  if (isNaN(number)) {
    throw new Error('Invalid rem value');
  }
  // return the number converted to px
  return remToPx(number, base);
}
